<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { init } from '@/common/outLink.js'

export default {
  name: 'App',
  components: {},
  data() {
    return {
      beginTime: 0, //开始时间
      differTime: 0, //时间差
    }
  },
  mounted() {
    init()
    window.addEventListener("beforeunload", () => this.beforeunloadHandler())
    window.addEventListener("unload", () => this.unloadHandler())
  },

  destroyed() {
    window.removeEventListener("beforeunload", () => this.beforeunloadHandler())
    window.removeEventListener("unload", () => this.unloadHandler())
  },

  methods: {
    beforeunloadHandler() {
      this.beforeUnloadTime = new Date().getTime()
    },
    unloadHandler() {
      this.gapTime = new Date().getTime() - this.beforeUnloadTime
      if (this.gapTime <= 5) { //判断是窗口关闭还是刷新，小于5代表关闭，否则就是刷新。
        console.log('关闭了浏览器')
        var storage = window.localStorage;
        // storage.clear()
        storage.removeItem('shop17173')
        storage.removeItem('shop9i173')
      }
    }
  }
}
</script>

